var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_106",
    "data-name": "Component 106",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3384",
    "data-name": "Path 3384",
    d: "M0,0H24V24H0Z",
    fill: "#fff",
    opacity: 0
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "menu_icon",
    "data-name": "menu icon",
    d: "M12.243,12.657,8,8.414,3.758,12.657a1,1,0,0,1-1.414-1.413L6.586,7,2.343,2.758A1,1,0,0,1,3.758,1.343L8,5.586l4.244-4.244a1,1,0,0,1,1.413,1.414L9.414,7l4.242,4.243a1,1,0,1,1-1.414,1.414Z",
    transform: "translate(4 5)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.b68541a6fbc39b2d1015a0fe2afeb2d5.svg";
export { ForwardRef as ReactComponent };